/* eslint-disable @typescript-eslint/no-explicit-any */
import { RootState } from '@/app/store';
import { ITracksId, SingleTrackState } from '@/interface';
import { beezerApi } from '@/services/deezer';

import { spotifyApi } from '@/services/spotify';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: SingleTrackState = {
  track: {} as ITracksId,
  isAutoPlay: false,
  isModalOpen: false,
  status: 'empty',
  trackId: {} as ITracksId,
  currentTime: 0,
  isCurrentTime: false
};

export const getSingleTRackByIdBeezer = createAsyncThunk(
  'singleTrack/getSingleTRackById',
  async (trackId: string) => {
    const response = await beezerApi(`track/${trackId}`);
    const result = await response.json();
    return {
      ...result,
      track: {
        name: result.title,
        album: {
          ...result.album,
          images: [
            {
              url: result.album.cover
            }
          ]
        },
        artists: [
          {
            ...result.artist,
            name: result.artist.name
          }
        ],
        preview_url: result.preview,
        id: result.id
      }
    };
  }
);

export const getSingleTrackBySpotify = createAsyncThunk(
  'singleTrack/getSingleTrackBySpotify',
  async (trackId: string) => {
    const response = await spotifyApi.getTrack(trackId);
    const result = response.body;
    return {
      ...result,
      track: {
        ...result
      }
    };
  }
);

export const singleTrackSlice = createSlice({
  name: 'singleTrack',
  initialState,
  reducers: {
    setTrackById: (
      state: SingleTrackState,
      action: PayloadAction<ITracksId>
    ) => {
      state.track = action.payload;
    },
    setAutoPlay: (state: SingleTrackState, action: PayloadAction<boolean>) => {
      state.isAutoPlay = action.payload;
    },
    setModalOpen: (state: SingleTrackState, action: PayloadAction<boolean>) => {
      state.isModalOpen = action.payload;
    },
    setTrackSingleId: (
      state: SingleTrackState,
      action: PayloadAction<ITracksId>
    ) => {
      state.trackId = action.payload;
    },
    setCurrentTime: (
      state: SingleTrackState,
      action: PayloadAction<number>
    ) => {
      state.currentTime = action.payload;
    },
    setIsUsingCurrentTime: (
      state: SingleTrackState,
      action: PayloadAction<boolean>
    ) => {
      state.isCurrentTime = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getSingleTRackByIdBeezer.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(getSingleTRackByIdBeezer.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(getSingleTRackByIdBeezer.fulfilled, (state, action) => {
      state.trackId = action.payload;
      state.status = 'ok';
    });
    builder.addCase(getSingleTrackBySpotify.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(getSingleTrackBySpotify.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(getSingleTrackBySpotify.fulfilled, (state, action) => {
      state.trackId = action.payload as any;
      state.status = 'ok';
    });
  }
});

export const {
  setTrackById,
  setAutoPlay,
  setModalOpen,
  setTrackSingleId,
  setCurrentTime,
  setIsUsingCurrentTime
} = singleTrackSlice.actions;
export const selectSingleTrack = (state: RootState) => state.singleTrack;
export default singleTrackSlice.reducer;
